<template>
  <div>
    <div v-if="data && data.length">
      <div class="item-contact text-blue mb-4 d-flex justify-content-between" v-for="(item, index) in menu" :key="`contact-list-${index}`" @click="submit(item)">
        <span> <v-icon class="text-blue">mdi-home-outline</v-icon> {{ item }} </span>
        <!-- <span
          ><v-btn outlined icon color="#23409a" x-small
            ><span class="fs-17" style="margin-left: 3px;"><v-img style="width:9px;height:auto" src="@/assets/vector.svg"></v-img></span></v-btn
        ></span> -->
      </div>
    </div>
    <div v-else>ไม่มีข้อมูลในระบบ</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      default: [], //contact //address
      type: Array,
    },
  },
  data() {
    return {
      menu: ["ที่อยู่ปัจจุบัน", "ที่อยู่ตามทะเบียนบ้าน", "ที่อยู่ที่ทำงาน", "ที่อยู่จัดส่งเอกสาร"],
    };
  },
  computed: {
    currentAddress() {
      return this.data.filter((x) => x.addressType == "ที่อยู่ปัจจุบัน");
    },
    homeAddress() {
      return this.data.filter((x) => x.addressType == "ที่อยู่ทะเบียนบ้าน");
    },
    workAddress() {
      return this.data.filter((x) => x.addressType == "ที่อยู่ทำงาน");
    },
    mailAddress() {
      return this.data.filter((x) => x.isMaillingAddress == "Yes");
    },
  },
  methods: {
    submit(menu) {
      let data = [];
      if (menu == "ที่อยู่ปัจจุบัน") {
        data = this.currentAddress;
      } else if (menu == "ที่อยู่ตามทะเบียนบ้าน") {
        data = this.homeAddress;
      } else if (menu == "ที่อยู่ที่ทำงาน") {
        data = this.workAddress;
      } else if (menu == "ที่อยู่จัดส่งเอกสาร") {
        data = this.mailAddress;
      }
      this.$store.state.addressType = menu;
      this.$emit("select-address", data, menu);
    },
  },
};
</script>
